import Repository from "./Repository";
import _ from "lodash";

const getPath = (path) => {
  return `admin/${path}`;
};
//API CALL for Admin Students flow
class AdminStudentRepository extends Repository {
  getAdminUsersList = async (params) => {
    try {
      const data = await this.postData(getPath(`users/fetch`), params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  createAdminStudent = async (params) => {
    try {
      const data = await this.postData(getPath("students/create"), params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  updateStudentStatus = async (params) => {
    try {
      const data = await this.putData(
        getPath("users/activate_deactivate"),
        params
      );
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  updateCourseStudentStatus = async (params) => {
    try {
      const data = await this.putData(
        getPath("students/course-disable"),
        params
      );
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  getAdminUsersNotRegisteredInCourse = async (courseId) => {
    try {
      const data = await this.getData(
        getPath(`students/notRegisteredForCourse/${courseId}`),
        {}
      );
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  //call students adding for courses
  addExistingStudentsToACourse = async (params) => {
    try {
      const data = await this.postData(getPath("students/addToCourse"), params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  getStudentProgress = async (params) => {
    try {
      const data = await this.postData(
        getPath("courses/studentCourseProgress"),
        params
      );
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  getStudentAttemptDetails = async (params) => {
    try {
      const data = await this.postData(
        getPath("quiz/studentAttemptsDetails"),
        params
      );
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  getAdminCourseDetails = async (params) => {
    try {
      const data = await this.getData(
        getPath(
          `students/detailFetchForStudent/${params.stdId}/${params.courseId}`
        ),
        {}
      );
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  resetCourseProgress = async (email) => {
    try {
      const data = await this.getData(
        `common/resetCourseProgress/${email}`,
        {}
      );
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  fetchStudentById = async (id) => {
    try {
      const data = await this.getData(
        getPath(`students/fetchStudentById/${id}`),
        {}
      );
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  updateStudent = async (id, params) => {
    try {
      const data = await this.putData(
        getPath(`students/update/${id}`),
        params
      );
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  updateStudentEnrollment = async (params) => {
   const { stdSearchQuery, ...payload } = params;
    try {
      const data = await this.postData(
        getPath(`students/updateStudentEnrollment`),
        payload
      );
      const response = _.get(data, `data`)
      return { ...response, stdSearchQuery }
    } catch (error) {
      return { error };
    }
  };

  deleteStudentReview = async (id) => {
    try {
      const data = await this.getData(getPath(`review/deleteByStudent/${id}`));
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };
}

export default new AdminStudentRepository("student");
